// extracted by mini-css-extract-plugin
module.exports = {"optionsContainer":"StockOptionsMatrix_optionsContainer___S6sb"};